module.exports = __webpack_public_path__ + "static/img/8a409926059ee06713bc3f3624a78e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_xinyun.png
// module id = JOmE
// module chunks = 1